<template>
    <div class="main-box mh-a">
        <iristar-dividing>{{ $t("HOME_NAV.about") }}</iristar-dividing>
        <img :src="about.titleImg" width="100%" alt="虹星科技" />
        <div class="fs14 text-indent lh30 mt20 c-g-d">
            <p class="mv20 m-about-text">{{ about.titleContent }}</p>
            <p class="mv20 m-about-text" v-for="(text, index) in about.produce" :key="`${index}_about`">
                {{ text }}
            </p>
        </div>
        <el-row type="flex" justify="space-around">
            <el-col :span="8" v-for="(item, idx) in about.people" :key="`${idx}_about_img`" class="text-center">
                <el-avatar :size="tSize" :class="{ mask: infoIndex !== idx }" :src="item.userImg"
                    @mouseover.native="selectInfo(idx)"></el-avatar>
            </el-col>
        </el-row>

        <div class="boss-box">
            <transition name="el-fade-in-linear">
                <div v-if="textShow">
                    <div class="fw-d">
                        <span class="d-i mr20">{{
            about.people[infoIndex].name
        }}</span>
                        <span>{{ about.people[infoIndex].position }}</span>
                    </div>
                    <p class="text-indent mt10">
                        {{ about.people[infoIndex].desc }}
                    </p>
                </div>
            </transition>
        </div>
        <iristar-history></iristar-history>
        <!-- <iristar-dividing>{{ $t("title.title7") }}</iristar-dividing> -->
        <!-- <el-row :gutter="20">
            <el-col :span="6" v-for="(ii, index) in about.media" :key="index" class="text-center">
                <img width="100%" :src="`./static/img/media/${ii.img}`" @click="jump(ii.link)" class="c-pointer" />
            </el-col>
        </el-row> -->
    </div>
</template>

<script>
import IristarDividing from "@/components/IristarDividing";
import IristarHistory from "@/components/IristarHistory";
import AboutList from "@/assets/about/aboutUs";
import AboutListEn from "@/assets/about/aboutUs-en";
export default {
    data() {
        return {
            infoIndex: 0,
            textShow: true,
            tSize: 200,
        };
    },
    created() {
        let innerW = window.innerWidth;
        this.tSize = innerW > 768 ? 200 : 100;
    },
    computed: {
        about() {
            return this.$store.state.language === "zh"
                ? AboutList
                : AboutListEn;
        },
    },
    methods: {
        selectInfo(index) {
            this.infoIndex = index;
            this.textShow = false;
            setTimeout(() => {
                this.textShow = true;
            }, 200);
        },
        jump(url) {
            window.open(url);
        },
    },
    components: { IristarDividing, IristarHistory },
    name: "iristarAbout",
};
</script>

<style lang="less"></style>